// lib
import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Button, Menu, MenuItem } from "@material-ui/core";
import ExpandMore from "@material-ui/icons/ExpandMore";

const Select = ({ defaultLabel, values, labels, selectCallback, initial }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selected, setSelected] = React.useState(initial);
  const { t } = useTranslation();
  const displayedLabels = labels || values;

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (newSelected) => {
    setSelected(newSelected);
    selectCallback(newSelected);
    handleClose();
  };

  const getButtonClassname = () =>
    selected ? `search-filter selected--${selected}` : "search-filter";

  const getItemClassname = (v) =>
    selected && v === selected ? `option--${v} option--selected` : `option--${v}`;

  return (
    <div>
      <Button
        onClick={handleOpen}
        className={getButtonClassname()}
        variant="outlined"
        endIcon={<ExpandMore />}
      >
        {selected || defaultLabel}
      </Button>
      <Menu
        className="filter-search"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={() => handleSelect(null)} className="option-all">
          {t("common.all")}
        </MenuItem>
        {values.map((v, i) => (
          <MenuItem key={v} onClick={() => handleSelect(v)} className={getItemClassname(v)}>
            {displayedLabels[i]}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

Select.propTypes = {
  // from parent
  defaultLabel: PropTypes.string.isRequired,
  values: PropTypes.array.isRequired,
  selectCallback: PropTypes.func.isRequired,
  labels: PropTypes.array,
  initial: PropTypes.string,
};

Select.defaultProps = {
  initial: null,
  labels: null,
};

export default Select;
